import React from 'react';
import { Paper, Box, Typography, Divider, Grid } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ColorPalette from '../../../colorpalette/ColorPalette';

const cardSx = {
  backgroundColor: ColorPalette.white,
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)',
  border: `1px solid ${ColorPalette.border}`,
  mb: 3
};

// Conteúdo das colunas: docs/features/subscription/matriz-de-planos.md, seção 2.
// Desde 2026-10-23 nada ao paciente sai pelo número da Gabriela: sem número
// próprio tudo sai pelo WhatsApp Web, com a mensagem pronta.
const BY_WEB = [
  'Confirmações, avisos e lembretes com a mensagem pronta, em um clique',
  'Pedido de confirmação com link para confirmar, reagendar ou cancelar'
];

const BY_OWN_NUMBER = [
  'Confirmações com resposta por botão e novo pedido a quem não respondeu, enviados sozinhos',
  'Avisos de agendamento, reagendamento e oferta de horário vago, na hora',
  'Lembrete de 7 dias, boas-vindas, pesquisa de satisfação, convite para avaliar no Google, aniversário e retorno após cancelamento',
  'Chat, envio de documentos e da nota fiscal, mensagens em massa e textos personalizados'
];

const Column = ({ title, items }) => (
  <Box>
    <Typography sx={{ fontWeight: 600, color: ColorPalette.textDark, mb: 1 }}>{title}</Typography>
    <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'grid', gap: 0.75 }}>
      {items.map((item) => (
        <Box component="li" key={item} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 18, color: ColorPalette.secondary, mt: '2px', flexShrink: 0 }} />
          <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>{item}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

/**
 * Card 2 da página de WhatsApp: a frase de produto e o quadro "Pelo WhatsApp Web" x
 * "Pelo seu número". Só informa; não depende do estado da conexão.
 *
 * @param {Object} props
 * @param {boolean} [props.ownNumberAllowed] Plano inclui número próprio
 */
const OriginOverviewCard = ({ ownNumberAllowed = true }) => (
  <Paper elevation={0} sx={cardSx}>
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      O que muda com o seu número
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
      Sem número próprio, a Gabriela deixa cada mensagem pronta e você envia pelo WhatsApp Web em
      um clique. Com o seu número conectado, as mensagens saem sozinhas pelo sistema.
    </Typography>
    {!ownNumberAllowed && (
      <Typography variant="body2" sx={{ mt: 1, color: ColorPalette.textDark, fontWeight: 500 }}>
        O número próprio está disponível a partir do plano Profissional.
      </Typography>
    )}

    <Divider sx={{ my: 2 }} />

    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Column title="Pelo WhatsApp Web" items={BY_WEB} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Column title="Pelo seu número" items={BY_OWN_NUMBER} />
      </Grid>
    </Grid>

    <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
      O resumo diário da agenda vai por e-mail, com ou sem número próprio.
    </Typography>
  </Paper>
);

export default OriginOverviewCard;
